/* ===================================================================

    Author          : Gnlab Theme
    Template Name   : 光年实验室是一家专门研究流量的公司。
    Version         : 1.4

* ================================================================= */

var resolveItems = [
  [
    { icon:'07',content:'到底该用个人微信还是用企业微信？',bolder:false },
    { icon:'07',content:'如何高效将淘宝\京东\拼多多\抖店里下单的用户引导至私域？',bolder:false },
    { icon:'10',content:'企微的账号、群总是被限制，号总是被封',bolder:true },
    { icon:'11',content:'企微加人总是提示过频，进粉受限',bolder:false },
  ],
  [
    { icon:'14',content:'现在一个人管理3、4个账号已经忙不过来了，如何让每个人管理更多的账号？',bolder:false },
    { icon:'11',content:'如何快速加客户微信好友？',bolder:false },
  ],
  [
    { icon:'07',content:'如何在私域里给用户种草？',bolder:false },
    { icon:'07',content:'客户加到私域之后怎样和他互动？',bolder:false },
    { icon:'11',content:'客户总是一加好友就删掉我怎么办？',bolder:true },
    { icon:'10',content:'微信群运营不了几天就死群了怎么办？',bolder:false },
  ],
  [
    { icon:'07',content:'一群发或者一发朋友圈就很多人删我怎么办？',bolder:false },
    { icon:'07',content:'私域积累的人不少，如何转化变现呢？',bolder:false },
    { icon:'10',content:'群太多管理不过来怎么办？',bolder:true },
  ],
];

var genResolveItem = function(icon,content){
  return '<div class="item" >'+
        '<div class="content" >'+
            '<span class="d-inline-block icon" >'+
                '<i class="d-inline-block spirits spirit-'+ icon +'" ></i>'+
            '</span>'+
            content +
        '</div>'+
    '</div>';
};

var genResolveFormMoble = function(){
  var fragment = document.createDocumentFragment();
  for(var i = 0 , lineLen = resolveItems.length; i < lineLen; i++){
    var items = resolveItems[i];
    var line = document.createElement('div');
    line.className = 'line';
    var lineWarp = document.createElement('div');
    lineWarp.className = 'line-warp';

    for(var itemCount = 0 , itemLen = items.length; itemCount < itemLen;itemCount++){
      const item = items[itemCount];
      line.innerHTML += genResolveItem(item.icon,item.content);
    }
    line.innerHTML += line.innerHTML;
    lineWarp.appendChild(line);
    fragment.appendChild(lineWarp);
  }
  return fragment;
};


window.addEventListener('DOMContentLoaded', () => {
  function initCustomersScroll() {
    const resolveMobleWarp = document.querySelector('.items-sm-warp .items')
    resolveMobleWarp.appendChild(genResolveFormMoble())

    const items = [...document.querySelectorAll('.resolve .items-sm-warp .line-warp .line')]
    items.forEach(item => { item.className += ' start' })
  }
  window.addEventListener('load', initCustomersScroll)
})
